import { useTheme } from '../../context/ThemeContext';
import { getLabels } from '../../constants/labels';
import './ThemeDayNightSwitch.css';

export function ThemeDayNightSwitch({ useMalayalam = false }) {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const labels = getLabels(useMalayalam);
  const isLight = resolvedTheme === 'light';
  const isSystem = theme === 'system';

  const handleChange = (e) => {
    setTheme(e.target.checked ? 'light' : 'dark');
  };

  const handleDoubleClick = () => {
    setTheme('system');
  };

  const hint = isSystem
    ? `${labels.themeSystem} — ${labels.themeSwitchHint}`
    : labels.themeSwitchHint;

  return (
    <div
      className={`theme-day-night-switch${isSystem ? ' theme-day-night-switch--system' : ''}`}
      title={hint}
    >
      <label className="switch">
        <input
          type="checkbox"
          checked={isLight}
          onChange={handleChange}
          onDoubleClick={handleDoubleClick}
          aria-label={labels.appearance}
          aria-checked={isLight}
        />
        <span className="slider">
          <div className="moons-hole">
            <div className="moon-hole" />
            <div className="moon-hole" />
            <div className="moon-hole" />
          </div>
          <div className="black-clouds">
            <div className="black-cloud" />
            <div className="black-cloud" />
            <div className="black-cloud" />
          </div>
          <div className="clouds">
            <div className="cloud" />
            <div className="cloud" />
            <div className="cloud" />
            <div className="cloud" />
            <div className="cloud" />
            <div className="cloud" />
            <div className="cloud" />
          </div>
          <div className="stars">
            <svg className="star" viewBox="0 0 20 20" aria-hidden>
              <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z" />
            </svg>
            <svg className="star" viewBox="0 0 20 20" aria-hidden>
              <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z" />
            </svg>
            <svg className="star" viewBox="0 0 20 20" aria-hidden>
              <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z" />
            </svg>
            <svg className="star" viewBox="0 0 20 20" aria-hidden>
              <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z" />
            </svg>
            <svg className="star" viewBox="0 0 20 20" aria-hidden>
              <path d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z" />
            </svg>
          </div>
        </span>
      </label>
    </div>
  );
}
